import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client/react';
import { LocationsContainer, LocationsTitle, LocationTitle } from './styled';
import FooterLocationsPlaceholder from '../../Placeholders/FooterLocationsPlaceholder';
import { getRowCount } from '../../SiteMap';
import { AdaptiveColumnContainer } from '../../../styled/common';
import { getStaticFooterData } from '../../../api/queries';
import { StaticFooterDataQuery } from '../../../graphql/graphql';

export const Locations: React.FC = () => {
  const { t } = useTranslation();

  const { data, loading } =
    useQuery<StaticFooterDataQuery>(getStaticFooterData);

  const cities = data?.cities || [];

  const regions = data?.regions || [];
  const mobCountOfRows = getRowCount(cities.length, 3);
  const tabletCountOfRows = getRowCount(cities.length, 5);
  const deskCountOfRows = getRowCount(cities.length, 7);

  const regionsMobCountOfRows = getRowCount(regions.length, 3);
  const regionsTabletCountOfRows = getRowCount(regions.length, 5);
  const regionsDeskCountOfRows = getRowCount(regions.length, 7);
  return (
    <LocationsContainer data-cy="locations">
      {loading && !regions.length ? (
        <FooterLocationsPlaceholder />
      ) : (
        <>
          <LocationsTitle data-cy="areas-title">
            {t('common.baki_areas')}
          </LocationsTitle>
          <AdaptiveColumnContainer
            data-cy="areas-block"
            $mobCountOfRows={regionsMobCountOfRows}
            $tabletCountOfRows={regionsTabletCountOfRows}
            $deskCountOfRows={regionsDeskCountOfRows}
          >
            {regions?.map(region => {
              return (
                <LocationTitle
                  data-cy="area"
                  key={region.slug}
                  href={`/${region.slug}`}
                  target="_blank"
                >
                  {region.name}
                </LocationTitle>
              );
            })}
          </AdaptiveColumnContainer>
        </>
      )}
      {loading && !cities.length ? (
        <FooterLocationsPlaceholder />
      ) : (
        <>
          <LocationsTitle data-cy="cities">
            {t('common.all_country')}
          </LocationsTitle>
          <AdaptiveColumnContainer
            data-cy="cities-block"
            $mobCountOfRows={mobCountOfRows}
            $tabletCountOfRows={tabletCountOfRows}
            $deskCountOfRows={deskCountOfRows}
          >
            {cities.map((city, index) => {
              return city ? (
                <LocationTitle
                  data-cy="cities-item-link"
                  key={`${city?.id}_${index}`}
                  href={`/${city?.slug}`}
                  target="_blank"
                >
                  {city?.name}
                </LocationTitle>
              ) : (
                <span key={index} />
              );
            })}
          </AdaptiveColumnContainer>
        </>
      )}
    </LocationsContainer>
  );
};
